// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2oeTE","inner":"header_inner__2JGFu","return":"header_return__3vF8_"};